import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Activiteit } from '../types/Activiteit'

export { completeActiviteitForEntity }

const completeActiviteitForEntity = async ({
  entity: { type, id },
  activiteitInfo: { _id, text },
  netbeheerderCodes,
}: {
  entity: Entity
  activiteitInfo: Pick<Activiteit, '_id' | 'text'>
  netbeheerderCodes?: string[]
}) => {
  const url = `/rest/${type}/${id}/activiteit/${_id}`

  await apiClient({
    url,
    method: 'PATCH',
    data: { status: 'done', text, netbeheerderCodes },
  })
}
